import React, { useId } from 'react';

/** Consistent campaign outcomes across channels, with optional follow-up details. */
export default function CampaignStatusCard({ title, eyebrow, description, statuses, actions, children, pending = false }) {
  const titleId = useId();
  return <section className="campaign-status-card card" aria-labelledby={titleId}>
    <div className="campaign-status-heading">
      <span className={`campaign-status-icon${pending ? ' is-pending' : ''}`} aria-hidden="true">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
          {pending ? <><circle cx="12" cy="12" r="8" /><path d="M12 7v5l3 2" /></> : <path d="m6 12 4 4 8-9" />}
        </svg>
      </span>
      <div className="campaign-status-copy">
        <p className="eyebrow">{eyebrow}</p>
        <h2 id={titleId}>{title}</h2>
        <p className="campaign-status-description">{description}</p>
        {statuses && <div className="launch-statuses">{statuses}</div>}
      </div>
    </div>
    {children && <div className="campaign-status-followup">{children}</div>}
    <div className="campaign-status-actions">{actions}</div>
  </section>;
}
